class HzProductTabs extends HTMLElement {
  connectedCallback() {
    this.addEventListener('click', this.#handleTabClick);
    this.#setActiveTab(0);
  }

  disconnectedCallback() {
    this.removeEventListener('click', this.#handleTabClick);
  }

  #handleTabClick = (event) => {
    const button = event.target.closest('[data-hz-product-tab]');
    if (!(button instanceof HTMLButtonElement) || !this.contains(button)) return;

    const index = Number(button.dataset.hzProductTab);
    if (!Number.isInteger(index)) return;
    this.#setActiveTab(index);
  };

  #setActiveTab = (index) => {
    const tabs = [...this.querySelectorAll('[data-hz-product-tab]')];
    const panels = [...this.querySelectorAll('[data-hz-product-panel]')];
    const track = this.querySelector('[data-hz-product-tab-track]');
    if (!track || index < 0 || index >= tabs.length || index >= panels.length) return;

    tabs.forEach((tab, tabIndex) => {
      const isActive = tabIndex === index;
      tab.setAttribute('aria-selected', String(isActive));
      tab.tabIndex = isActive ? 0 : -1;
    });
    panels.forEach((panel, panelIndex) => panel.setAttribute('aria-hidden', String(panelIndex !== index)));
    track.style.transform = `translateX(-${index * 100}%)`;
  };
}

if (!customElements.get('hz-product-tabs')) {
  customElements.define('hz-product-tabs', HzProductTabs);
}
